{
  "title": "Shatter",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level evocation",
  "level": 2,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a chip of mica)",
  "duration": "Instantaneous",
  "description": [
    "A sudden loud ringing noise, painfully intense, erupts from a point of your choice within range. Each creature in a 10-foot-radius sphere centered on that point must make a Constitution saving throw. A creature takes 3d8 thunder damage on a failed save, or half as much damage on a successful one. A creature made of inorganic material such as stone, crystal, or metal has disadvantage on this saving throw.",
    "A nonmagical object that isn’t being worn or carried also takes the damage if it’s in the spell’s area.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, the damage increases by 1d8 for each slot level above 2nd."
  ],
  "spellLists": ["bard", "eldritch-knight", "sorcerer", "warlock", "wizard"]
}
